document.addEventListener("DOMContentLoaded", () => {
  const mainInfo = document.querySelector(".ingredient-tab__main-info");
  const buttons = document.querySelectorAll(".ingredient-tab__button");

  const mainImg = mainInfo.querySelector("img");
  const mainTitle = mainInfo.querySelector(".ingredient-tab__title");
  const mainContent = mainInfo.querySelector(".ingredient-tab__content");
  const mainWeight = mainInfo.querySelector(".ingredient-tab__weight");

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      // Update active button
      document
        .querySelector(".ingredient-tab__button.active")
        ?.classList.remove("active");

      button.classList.add("active");

      // Update main content
      mainImg.src = button.dataset.img;
      mainTitle.textContent = button.dataset.title;
      mainContent.textContent = button.dataset.content;
      mainWeight.textContent = button.dataset.weight;
      mainImg.alt = button.dataset.alt;
    });
  });
});